<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Контрагенты</h2>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text fab color="primary" @click="dialogNewOrg = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
      <v-dialog
        v-model="dialogNewOrg"
        scrollable
        persistent :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="px-3">
          <v-card-title primary-title>
            Добавление контрагента
          </v-card-title>
          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
            <v-text-field label="orgid" v-model="newOrg.orgid" clearable></v-text-field>
            <v-text-field label="Наименование" v-model="newOrg.title" clearable></v-text-field>
            <v-text-field label="Описание" v-model="newOrg.description" clearable></v-text-field>
            <v-text-field label="ИНН" v-model="newOrg.inn" type="number" clearable></v-text-field>
            <v-text-field label="Юридический адрес" v-model="newOrg.address" clearable></v-text-field>
            <v-text-field label="Порядок отображения" v-model="newOrg.showorder" type="number" clearable></v-text-field>
            <v-select
              :items="activitytypes"
              item-value="activitytypeid"
              item-text="title"
              v-model="newOrg.activitytypeid"
              label="Тип деятельности организации"
            ></v-select>
          </v-flex>
          <v-card-actions>
            <v-btn color="primary" @click="saveOrg" :disabled="checkNewOrgFilled">Сохранить</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialogNewOrg = false; drop()">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="updateOrgDialog"
        persistent :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="px-3">
          <v-card-title primary-title>
            Изменение информации организации
          </v-card-title>
          <v-text-field label="Название компании" v-model="currentOrg.orgName"></v-text-field>
          <v-text-field label="Юридический адрес" v-model="currentOrg.address"></v-text-field>
          <v-text-field label="Описание компании" v-model="currentOrg.description"></v-text-field>
          <v-text-field label="Номер отображения в отчете" v-model="currentOrg.showorder"></v-text-field>
          <v-card-actions>
            <v-btn color="success" @click="updateOrg()">Сохранить</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="updateOrgDialog = false;">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
        <v-data-table
          no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="activities"
          item-key="activityid"
          :items-per-page="-1"
          :search="search"
          sort-by="activityid"
          dense
          hide-default-footer
        >
        <template v-slot:item.activitytypeid="{ item }">
          <span>{{ item.activitytypeid }}</span>
        </template>
        <template v-slot:item.balance="{ item }">
          <span v-if="item.balance < 0" style="color:#FF5252;">{{ rubles(item.balance) }}</span>
          <span v-else style="color:#448AFF;">{{ rubles(item.balance) }}</span>
        </template>
        <template v-slot:item.closed="{ item }">
          <span v-if="item.closed === null" style="color:#00C853;">Работает</span>
          <span v-else style="color:#FF5252;">{{ dateFormat(item.closed) }}</span>
        </template>
        <template v-slot:item.cts="{ item }">
          <span>{{ dateFormat(item.orgCts) }}</span>
        </template>
        <template v-slot:item.orgName="{ item }" max-width="200px">
          <v-tooltip left max-width="640">
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on">{{ item.orgName }}</span>
            </template>
            <span>
              <span><strong>Наименование: </strong>{{ item.orgName }}</span>
              <br>
              <span><strong>ИНН</strong>: {{ item.inn }}</span>
              <br>
              <span><strong>Адрес</strong>: {{ item.address }}</span>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }" v-if="isadmin">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">more_vert</v-icon>
            </template>
            <v-list>
              <v-list-item
                v-if="item.closed === null"
                @click=";updateActivity(item, 'close')"
              >
                <v-list-item-title>Закрыть контрагента <b>{{ item.orgName }} @ {{ item.activitytypeid }}</b></v-list-item-title>
                <v-list-item-action><v-icon>close</v-icon></v-list-item-action>
              </v-list-item>
              <v-list-item
                v-else
                @click=";updateActivity(item, 'open')"
              >
                <v-list-item-title>Открыть контрагента <b>{{ item.orgName }} @ {{ item.activitytypeid }}</b></v-list-item-title>
                <v-list-item-action><v-icon>open</v-icon></v-list-item-action>
              </v-list-item>
              <v-list-item
                @click="currentOrg = { ...item }; updateOrgDialog = true;"
              >
                <v-list-item-title>Изменить данные контрагента <b>{{ item.orgName }} @ {{ item.activitytypeid }}</b></v-list-item-title>
                <v-list-item-action><v-icon>update</v-icon></v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Orgs',
  data: () => ({
    orgs: [],
    activities: [],
    activitytypes: [],
    search: '',
    dialogNewOrg: false,
    updateOrgDialog: false,
    currentOrg: {},
    step: 1,
    newOrg: {
      orgid: null,
      title: null,
      description: null,
      inn: null,
      address: null,
      showorder: null,
      activitytypeid: null
    },
  }),
  methods: {
    async fetch () {
      try {
        const { orgs } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-orgs',
          pl: {}
        })
        this.orgs = orgs
        const { activities } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-activities',
          pl: {}
        })
        this.activities = activities
        this.activities.map(x => {
          const curOrg = this.orgs.find(o => o.orgid === x.orgid)
          x.orgName = curOrg.title
          x.orgCts = curOrg.cts
          x.showorder = curOrg.showorder
          x.inn = curOrg.details.inn
          x.address = curOrg.details.address
          x.description = curOrg.description
          return x
        })
        const { activitytypes } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-activitytypes',
          pl: {}
        })
        this.activitytypes = activitytypes
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return parseFloat(kops / 100).toFixed(2)
    },
    async updateActivity (org, status) {
      try {
        if (org && status) {
          const { meta } = await this.$store.dispatch('sioRequest', {
            topic: 'activity-update',
            pl: {
              orgid: org.orgid,
              activitytypeid: org.activitytypeid,
              status: status
            }
          })
          this.$store.dispatch('snack', meta)
          await this.fetch()
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    drop () {
      Object.keys(this.newOrg).forEach(key => {
        this.newOrg[key] = null
      })
      this.step = 1
      this.currentOrg = {}
    },
    async saveOrg () {
      const { meta } = await this.$store.dispatch('sioRequest', {
        topic: 'add-org',
        pl: {
          ...this.newOrg,
          details: {
            inn: this.newOrg.inn,
            address: this.newOrg.address
          }

        }
      })
      this.$store.dispatch('snack', meta)
      await this.saveOrgActivity()
    },
    async saveOrgActivity () {
      const { meta } = await this.$store.dispatch('sioRequest', {
        topic: 'add-activity',
        pl: this.newOrg
      })
      this.$store.dispatch('snack', meta)
      this.drop()
      this.dialogNewOrg = false
      this.fetch()
    },
    async updateOrg () {
      const { meta } = await this.$store.dispatch('sioRequest', {
        topic: 'update-org',
        pl: {
          ...this.currentOrg,
          details: {
            address: this.currentOrg.address
          },
          title: this.currentOrg.orgName
        }
      })
      this.$store.dispatch('snack', meta)
      this.currentOrg = {}
      this.updateOrgDialog = false
      this.fetch()
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    headers () {
      return [
        { text: 'id', value: 'activityid', align: 'left' },
        { text: 'orgid', value: 'orgid', align: 'left' },
        { text: 'Название', value: 'orgName', align: 'left' },
        { text: 'Деятельность', value: 'activitytypeid', align: 'left' },
        { text: 'Баланс', value: 'balance', align: 'left' },
        { text: 'Закрыт?', value: 'closed' },
        { text: 'Создан', value: 'cts' },
        { text: 'Порядок отображения', value: 'showorder' },
        { text: 'действия', value: 'action', align: 'center', sortable: false },
      ]
    },
    checkNewOrgFilled () {
      return Object.values(this.newOrg).some(value => value == null)
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css" scoped>
</style>
